export const templateOfTextTableBlock = `
    <div class="row content-block">
        <div class="col-12 column px-8 py-4">
            <table>
                <tr>
                    <th><p></p></th>
                    <th><p></p></th>
                    <th><p></p></th>
                </tr>
                <tr>
                    <td><p></p></td>
                    <td><p></p></td>
                    <td><p></p></td>
                </tr>
                <tr>
                    <td><p></p></td>
                    <td><p></p></td>
                    <td><p></p></td>
                </tr>
            </table>
        </div>
    </div>
`
